export const view = {
    methods:{     
        login: function (e) {
            e.preventDefault();
            var _self = this;
            var returnUrl = _self.getParameterByName('returnUrl');

            var parameters = _self.getFormModel('login');
            parameters.FranchiseID = localStorage.franchiseID;
            _self.$ooApi.orders.accounts.login.v1(parameters).then(function(response){
                if(response.success){
                    localStorage.setItem('userToken', response.data.token);
                    localStorage.setItem('userMembershipID', response.data.membershipUserId);
                    _self.$ooApi.authenticate(parameters.Username, parameters.Password).then(function () {
                        _self.$isLoggedIn = true;
                        
                        if(returnUrl)
                            _self.redirect(returnUrl);
                        else
                        _self.$router.push('Menu');
                    })
                }
                else
                    console.log(response.message);
            })
            // check .catch
        }
    }
}